"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const PT = __importStar(require("prop-types"));
require("nav-frontend-snakkeboble-style");
const nav_frontend_paneler_1 = __importDefault(require("nav-frontend-paneler"));
const nav_frontend_typografi_1 = require("nav-frontend-typografi");
const snakkebobleCls = (hoyre, className) => (0, classnames_1.default)("snakkeboble", ...className.split(" "), {
    "snakkeboble--hoyre": hoyre,
    "snakkeboble--venstre": !hoyre,
});
/**
 * En snakkeboble for dialog
 */
class Snakkeboble extends React.Component {
    render() {
        const _a = this.props, { dato, topp, children, pilHoyre, ikonClass, className } = _a, rest = __rest(_a, ["dato", "topp", "children", "pilHoyre", "ikonClass", "className"]);
        const toppTekst = topp || dato;
        return (React.createElement("div", Object.assign({ className: snakkebobleCls(pilHoyre, className) }, rest),
            React.createElement("i", { className: ikonClass }),
            React.createElement("div", { className: "snakkeboble__snakkeboble-pil-container" },
                React.createElement("i", { className: "snakkeboble__snakkebole-pil" })),
            React.createElement(nav_frontend_paneler_1.default, { className: "snakkeboble-panel" },
                toppTekst && (React.createElement(nav_frontend_typografi_1.Undertekst, { className: "snakkeboble-panel__topp" }, toppTekst)),
                React.createElement("div", { className: "snakkeboble-panel__tekst" }, children))));
    }
}
Snakkeboble.defaultProps = {
    /**
     * Default er at pilen peker mot venstre
     */
    pilHoyre: false,
    /**
     * Gir enkel default styling på ikoner
     */
    ikonClass: "snakkeboble__ikon",
    /**
     * @Deprecated Bruk `topp`-prop
     */
    dato: null,
    /**
     * Egendefinerte klassenavn
     */
    className: "",
};
Snakkeboble.propTypes = {
    /**
     * Toppteksten (tittel) for meldingen
     */
    topp: PT.string,
    /**
     * @Deprecated Dato for melding, bruk `topp`
     */
    dato: PT.string,
    /**
     * Tekst for melding
     */
    children: PT.node.isRequired,
    /**
     * Settes denne peker pilen til snakkeboblen mot høyre, og snakkeboblen og teksten i snakkeboblen flyter mot høyre.
     */
    pilHoyre: PT.bool,
    /**
     * Klasse som brukes på ikonet. Dette lar deg styre form, farge og illustrasjon.
     */
    ikonClass: PT.string,
    /**
     * Egendefinerte klassenavn
     */
    className: PT.string,
};
exports.default = Snakkeboble;
